import { Subject } from 'rxjs/Subject';
var DraggableHelper = (function () {
    function DraggableHelper() {
        this.currentDrag = new Subject();
    }
    return DraggableHelper;
}());
export { DraggableHelper };
//# sourceMappingURL=draggableHelper.provider.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-draggable-droppable/dist/esm/src/draggableHelper.provider.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/draggableHelper.provider.js
// module chunks = 42